<div class="container">
  <mat-card class="militar-info" *ngIf="beneficiario">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matricula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Orgao:</strong> {{ beneficiario.orgao?.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="9"></app-etapas-beneficio>

  <h1 class="page-title">Anexar Documentos</h1>

  <!-- Seletor de Tipo de Beneficio -->
  <mat-card class="tipo-beneficio-card">
    <h3 class="section-title">Alterar Tipo de Beneficio</h3>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Selecione o tipo de beneficio</mat-label>
      <mat-select [(ngModel)]="tipoBeneficioSelecionado" (selectionChange)="onTipoBeneficioChange()">
        <mat-option *ngFor="let tipo of tiposBeneficio" [value]="tipo.id">
          {{ tipo.nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-stroked-button (click)="salvarChecklist()" [disabled]="!tipoBeneficioSelecionado">Salvar hipótese e aplicabilidade</button>
    <div *ngFor="let d of documentos">
      <label *ngIf="d.condicao && d.codigo">{{d.nome}} — aplicabilidade:
        <select [ngModel]="contextoMilitar.aplicabilidadeChecklist[d.codigo]?.startsWith('NAO_APLICAVEL:') ? 'NAO_APLICAVEL:' : contextoMilitar.aplicabilidadeChecklist[d.codigo]" (ngModelChange)="contextoMilitar.aplicabilidadeChecklist[d.codigo]=$event"><option value="">Informe</option><option value="APLICAVEL">Aplica-se</option><option value="NAO_APLICAVEL:">Não se aplica (justifique abaixo)</option></select>
        <input *ngIf="contextoMilitar.aplicabilidadeChecklist[d.codigo]?.startsWith('NAO_APLICAVEL:')" [ngModel]="contextoMilitar.aplicabilidadeChecklist[d.codigo]?.substring(14)" (ngModelChange)="contextoMilitar.aplicabilidadeChecklist[d.codigo]='NAO_APLICAVEL:'+$event" placeholder="Justifique por que não se aplica">
      </label>
    </div>
    <p class="tipo-descricao" *ngIf="tipoBeneficioSelecionado">
      {{ getTipoBeneficioDescricao() }}
    </p>
  </mat-card>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Carregando documentos...</p>
  </div>

  <!-- Falha ao carregar os documentos anexados: o status abaixo não foi verificado -->
  <div *ngIf="erroAnexados" class="erro-anexados" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ erroAnexados }}</span>
  </div>

  <!-- Lista de Documentos -->
  <div *ngIf="!loading && documentos.length > 0" class="documentos-container">

    <!-- Resumo + ação de assinatura -->
    <mat-card class="resumo-card">
      <div class="resumo-content">
        <span class="resumo-label">Documentos Anexados:</span>
        <span class="resumo-valor">{{ getTotalAnexados() }} / {{ getTotalDocumentos() }}</span>
      </div>

      <div class="resumo-acoes">
        <span *ngIf="assinandoLote" class="progresso-assinatura">
          <mat-spinner diameter="18"></mat-spinner>
          Assinando {{ progressoAssinatura.atual }} de {{ progressoAssinatura.total }}...
        </span>

        <button
          *ngIf="!assinandoLote && getDocumentosPendentesAssinatura().length > 0"
          mat-flat-button
          color="primary"
          (click)="assinarPendentes()">
          <mat-icon>edit_note</mat-icon>
          Assinar Documentos Pendentes ({{ getDocumentosPendentesAssinatura().length }})
        </button>
      </div>
    </mat-card>

    <!-- Documentos de Identificacao -->
    <mat-card class="documentos-card">
      <h3 class="section-title">
        <mat-icon>badge</mat-icon>
        Documentos de Identificacao do Militar
      </h3>

      <table mat-table [dataSource]="getDocumentosIdentificacao()" class="documentos-table">
        <!-- Nome -->
        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef>Documento</th>
          <td mat-cell *matCellDef="let doc">
            {{ doc.nome }}
            <span class="obrigatorio" *ngIf="doc.obrigatorio">*</span>
          </td>
        </ng-container>

        <!-- Categoria -->
        <ng-container matColumnDef="categoria">
          <th mat-header-cell *matHeaderCellDef>Categoria</th>
          <td mat-cell *matCellDef="let doc">
            <mat-chip>Identificacao</mat-chip>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let doc">
            <span *ngIf="doc.uploading" class="status-enviando">
              <mat-spinner diameter="16"></mat-spinner>
              Enviando...
            </span>
            <span *ngIf="!doc.uploading" [class]="'status-badge ' + getStatusClass(doc.status)">
              {{ getStatusLabel(doc.status) }}
            </span>
          </td>
        </ng-container>

        <!-- Assinado -->
        <ng-container matColumnDef="assinado">
          <th mat-header-cell *matHeaderCellDef>Assinado</th>
          <td mat-cell *matCellDef="let doc">
            <span *ngIf="doc.signing" class="status-assinando">
              <mat-spinner diameter="16"></mat-spinner>
              Assinando...
            </span>
            <span *ngIf="!doc.signing && doc.assinado" class="status-assinado">
              <mat-icon class="icon-check">check_circle</mat-icon>
              Assinado
            </span>
            <span *ngIf="!doc.signing && !doc.assinado && doc.status === 'presente'" class="status-aguardando">
              Aguardando
            </span>
            <span *ngIf="!doc.signing && !doc.assinado && doc.status !== 'presente'" class="status-na">
              —
            </span>
          </td>
        </ng-container>

        <!-- Acoes -->
        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef>Acoes</th>
          <td mat-cell *matCellDef="let doc">
            <div class="acoes-buttons">
              <button
                mat-icon-button
                color="primary"
                (click)="triggerUpload(doc)"
                [disabled]="doc.uploading"
                matTooltip="Anexar documento">
                <mat-icon>upload_file</mat-icon>
              </button>

              <button
                mat-icon-button
                color="accent"
                (click)="downloadDocumento(doc)"
                [disabled]="doc.status !== 'presente' || doc.uploading"
                matTooltip="Baixar documento">
                <mat-icon>download</mat-icon>
              </button>

              <button
                mat-icon-button
                color="warn"
                (click)="excluirDocumento(doc)"
                [disabled]="doc.status !== 'presente' || doc.uploading"
                matTooltip="Excluir documento">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            [class.row-presente]="row.status === 'presente'"></tr>
      </table>
    </mat-card>

    <!-- Documentos Funcionais -->
    <mat-card class="documentos-card">
      <h3 class="section-title">
        <mat-icon>folder_shared</mat-icon>
        Documentos Funcionais do Militar
      </h3>

      <table mat-table [dataSource]="getDocumentosFuncionais()" class="documentos-table">
        <!-- Nome -->
        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef>Documento</th>
          <td mat-cell *matCellDef="let doc">
            {{ doc.nome }}
            <span class="obrigatorio" *ngIf="doc.obrigatorio">*</span>
          </td>
        </ng-container>

        <!-- Categoria -->
        <ng-container matColumnDef="categoria">
          <th mat-header-cell *matHeaderCellDef>Categoria</th>
          <td mat-cell *matCellDef="let doc">
            <mat-chip color="primary">Funcional</mat-chip>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let doc">
            <span *ngIf="doc.uploading" class="status-enviando">
              <mat-spinner diameter="16"></mat-spinner>
              Enviando...
            </span>
            <span *ngIf="!doc.uploading" [class]="'status-badge ' + getStatusClass(doc.status)">
              {{ getStatusLabel(doc.status) }}
            </span>
          </td>
        </ng-container>

        <!-- Assinado -->
        <ng-container matColumnDef="assinado">
          <th mat-header-cell *matHeaderCellDef>Assinado</th>
          <td mat-cell *matCellDef="let doc">
            <span *ngIf="doc.signing" class="status-assinando">
              <mat-spinner diameter="16"></mat-spinner>
              Assinando...
            </span>
            <span *ngIf="!doc.signing && doc.assinado" class="status-assinado">
              <mat-icon class="icon-check">check_circle</mat-icon>
              Assinado
            </span>
            <span *ngIf="!doc.signing && !doc.assinado && doc.status === 'presente'" class="status-aguardando">
              Aguardando
            </span>
            <span *ngIf="!doc.signing && !doc.assinado && doc.status !== 'presente'" class="status-na">
              —
            </span>
          </td>
        </ng-container>

        <!-- Acoes -->
        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef>Acoes</th>
          <td mat-cell *matCellDef="let doc">
            <div class="acoes-buttons">
              <button
                mat-icon-button
                color="primary"
                (click)="triggerUpload(doc)"
                [disabled]="doc.uploading"
                matTooltip="Anexar documento">
                <mat-icon>upload_file</mat-icon>
              </button>

              <button
                mat-icon-button
                color="accent"
                (click)="downloadDocumento(doc)"
                [disabled]="doc.status !== 'presente' || doc.uploading"
                matTooltip="Baixar documento">
                <mat-icon>download</mat-icon>
              </button>

              <button
                mat-icon-button
                color="warn"
                (click)="excluirDocumento(doc)"
                [disabled]="doc.status !== 'presente' || doc.uploading"
                matTooltip="Excluir documento">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            [class.row-presente]="row.status === 'presente'"></tr>
      </table>
    </mat-card>
  </div>

  <!-- Mensagem quando nenhum tipo selecionado -->
  <mat-card class="empty-card" *ngIf="!loading && documentos.length === 0 && !tipoBeneficioSelecionado">
    <mat-icon>info</mat-icon>
    <p>Selecione um tipo de beneficio para visualizar os documentos necessarios.</p>
  </mat-card>

  <!-- Outros documentos anexados: documentos conferidos na abertura fora do checklist (laudo e requerimento da tela inicial,
       comprovantes das abas 4 a 6). Fica fora do bloco do checklist para não sumir quando o checklist falha ou não há hipótese. -->
  <div *ngIf="!loading && outrosDocumentos.length > 0" class="documentos-container outros-container">
    <mat-card class="documentos-card outros-card">
      <h3 class="section-title">
        <mat-icon>attach_file</mat-icon>
        Outros documentos anexados
      </h3>
      <p class="outros-aviso">
        Documentos anexados ao militar que não correspondem a nenhum item do checklist, como o laudo e o
        requerimento enviados na tela de requerimento e os comprovantes das abas Alterações Funcionais,
        Deduções e Acréscimos. A abertura do processo exige que eles também estejam assinados. Eles não
        entram na assinatura em lote: use as ações de cada linha.
        Documento assinado não pode ser excluído.
      </p>

      <table mat-table [dataSource]="outrosDocumentos" class="documentos-table">
        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef>Tipo do documento</th>
          <td mat-cell *matCellDef="let doc">{{ doc.nome }}</td>
        </ng-container>

        <ng-container matColumnDef="arquivo">
          <th mat-header-cell *matHeaderCellDef>Arquivo</th>
          <td mat-cell *matCellDef="let doc">{{ doc.arquivo || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="assinado">
          <th mat-header-cell *matHeaderCellDef>Assinado</th>
          <td mat-cell *matCellDef="let doc">
            <span *ngIf="doc.signing" class="status-assinando">
              <mat-spinner diameter="16"></mat-spinner>
              Assinando...
            </span>
            <span *ngIf="!doc.signing && doc.assinado" class="status-assinado">
              <mat-icon class="icon-check">check_circle</mat-icon>
              Assinado
            </span>
            <span *ngIf="!doc.signing && !doc.assinado" class="status-aguardando">
              Aguardando
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef>Acoes</th>
          <td mat-cell *matCellDef="let doc">
            <div class="acoes-buttons">
              <button
                mat-icon-button
                color="accent"
                data-testid="baixar-outro"
                (click)="downloadDocumento(doc)"
                [disabled]="doc.uploading"
                matTooltip="Baixar documento">
                <mat-icon>download</mat-icon>
              </button>

              <button
                mat-icon-button
                color="primary"
                data-testid="assinar-outro"
                (click)="assinarOutroDocumento(doc)"
                [disabled]="doc.assinado || doc.signing || doc.uploading || assinandoLote || !doc.hash"
                matTooltip="Assinar documento">
                <mat-icon>edit_note</mat-icon>
              </button>

              <!-- O tooltip fica no span: botão desabilitado não dispara o tooltip -->
              <span [matTooltip]="doc.assinado ? 'Documento assinado não pode ser excluído' : 'Excluir documento'">
                <button
                  mat-icon-button
                  color="warn"
                  data-testid="excluir-outro"
                  (click)="excluirOutroDocumento(doc)"
                  [disabled]="doc.assinado || doc.uploading || doc.signing">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasOutros"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasOutros" class="row-presente"></tr>
      </table>
    </mat-card>
  </div>

  <div *ngIf="!loading && documentos.length > 0" class="documentos-container">
    <!-- Botoes de Acao -->
    <div class="acoes-container">
      <button mat-flat-button color="primary" (click)="salvar()">
        <mat-icon>save</mat-icon> Salvar Documentos
      </button>
    </div>
  </div>

  <!-- Input de arquivo oculto -->
  <input
    type="file"
    #fileInput
    style="display: none"
    (change)="onFileSelected($event)"
    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx">
</div>
